<crm-navigation-bar *ngIf="isAuthenticated()" (toggleSidenav)="navigationSidenav.toggle()">
</crm-navigation-bar>

<mat-sidenav-container autosize>

  <mat-sidenav #navigationSidenav mode="over" role="navigation">

    <mat-toolbar>
      <mat-toolbar-row>
        <h2 class="toolbar-title"> {{ 'APP_TOOLBAR_TITLE' | translate }} </h2>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-nav-list>

      <h2 matSubheader> {{ 'MY_WORK' | translate }} </h2>

      <a mat-list-item routerLink="/" style="height: 0;"></a>

      <a *ngFor="let item of myWorkRoutes"
        mat-list-item
        (click)="navigationSidenav.close()"
        [routerLink]="[item.route]"
        routerLinkActive="list-item-active">
        <mat-icon matListIcon class="app-nav-list-icon"> {{ item.icon }} </mat-icon>
        {{item.title}}
      </a>

      <mat-divider></mat-divider>

      <h2 matSubheader> {{ 'CUSTOMERS' | translate }} </h2>

      <a *ngFor="let item of customerRoutes"
        mat-list-item
        (click)="navigationSidenav.close()"
        [routerLink]="[item.route]"
        routerLinkActive="list-item-active">
        <mat-icon matListIcon class="app-nav-list-icon"> {{ item.icon }} </mat-icon>
        {{item.title}}
      </a>

    </mat-nav-list>

  </mat-sidenav>

  <mat-sidenav #commandbarSidenav position="end" mode="side" class="crm-command-bar-sidenav">

    <mat-list style="padding: 10px;">

      <mat-card *ngFor="let item of toolPaletteItems" style="padding: 8px; margin-bottom: 10px; text-align: center;">

        <img mat-card-sm-image
             [src]="item.icon"
             [alt]="item.name"
             draggable="true"
             (dragstart)="onDragStart($event, item.id)">

        <mat-card-content>
          <mat-card-subtitle>
            {{item.name}}
          </mat-card-subtitle>
        </mat-card-content>

      </mat-card>

    </mat-list>

    <!--
    <mat-nav-list>

      <a *ngFor="let item of toolPaletteItems"
        mat-list-item>
        <img matListIcon
             [src]="item.icon"
             [alt]="item.name"
             class="app-nav-list-icon"
             draggable="true" (dragstart)="onDragStart($event, item.id)">
        {{item.name}}
      </a>

    </mat-nav-list>
    -->

  </mat-sidenav>

  <mat-sidenav-content role="main">
    <!--
    <crm-navigation-bar *ngIf="isAuthenticated()" (toggleSidenav)="navigationSidenav.toggle()">
    </crm-navigation-bar>
    -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>

</mat-sidenav-container>
